export default function Contact() {
  const contactInfo = [
    {
      icon: 'ri-mail-line',
      label: 'Email',
      value: 'billplaycustoms@gmail.com',
      link: 'mailto:billplaycustoms@gmail.com'
    },
    {
      icon: 'ri-phone-line',
      label: 'Phone',
      value: '269-993-2813',
      link: 'tel:269-993-2813'
    },
    {
      icon: 'ri-map-pin-line',
      label: 'Service Areas',
      value: 'Kalamazoo & Grand Rapids',
      link: null
    }
  ];

  return (
    <section id="contact" className="py-32 px-8 bg-[#0A0A0A]">
      <div className="max-w-[1400px] mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 border border-white/20 rounded-full px-5 py-2 mb-8">
            <span className="text-xs font-bold text-white tracking-wide">GET IN TOUCH</span>
          </div>

          <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-white leading-[0.95] tracking-tight mb-8">
            Contact<br />
            BillPlay
          </h2>

          <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
            Questions about orders, products, or local delivery? We're here to help.
          </p>
        </div>

        {/* Contact Cards */}
        <div className="grid md:grid-cols-3 gap-8 max-w-[1200px] mx-auto">
          {contactInfo.map((item, index) => (
            <div 
              key={index}
              className="bg-[#181818] border border-[#333333] rounded-2xl p-8 text-center hover:border-white/30 transition-all duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center mx-auto mb-6">
                <i className={`${item.icon} text-4xl text-white`}></i>
              </div>
              
              <div className="text-sm font-bold text-gray-400 mb-3 tracking-wide">
                {item.label}
              </div>
              
              {item.link ? (
                <a 
                  href={item.link}
                  className="text-xl font-bold text-white hover:underline"
                >
                  {item.value}
                </a>
              ) : (
                <div className="text-xl font-bold text-white">
                  {item.value}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Brand Statement */}
        <div className="mt-20 text-center">
          <div className="text-6xl md:text-7xl font-black text-white mb-6">
            BILLPLAY
          </div>
          <div className="text-lg text-gray-400">
            Culture Over Everything
          </div>
        </div>
      </div>
    </section>
  );
}